import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getEquipmentFields() {
  const response = await defaultFetch('/form/Equipment/Fields');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response;
}

export function useEquipmentFields() {
  return useQuery({
    queryKey: ['equipment-fields'],
    queryFn: async () => getEquipmentFields(),
    refetchOnWindowFocus: false
  });
}
